import './data-entry-parent.css'

export function DataEntryParent(props: { children: any; text?: string; style?: any }) {
  return (
    <div className="parent" style={props.style}>
      <div className="text">{props.text}</div>
      {props.children}
    </div>
  )
}

export function DataEntryHalfParent(props: { children: any; text?: string }) {
  return (
    <div className="half-parent">
      <div className="text">{props.text}</div>
      {props.children}
    </div>
  )
}
